import { roles as agentRoles } from "@/helpers/get_constants";

export default {
  getIsAgentAuthenticated(state) {
    return state.isAgentAuthenticated;
  },
  getAgent(state) {
    return state.agent;
  },
  getAgents(state) {
    return state.agents;
  },
  getAvailableAgents(state) {
    return state.agents?.filter((a) => a.active);
  },
  getAllAgentsArray(state) {
    return state.allAgents;
  },
  getAllAgentsMap(state) {
    return state.allAgentsMap;
  },
  getAgentsToArray(state) {
    let agent, agents;
    if (state.agents) {
      agents = [];
      for (let a in state.agents) {
        agent = state.agents[a];
        if (agent.active) agents.push({ uid: a, ...agent });
      }
    }
    return agents;
  },
  getAgentRoles(state) {
    return state.agentRoles;
  },
  getAvailableAgentRoles(state) {
    if (state.agent.role === agentRoles.ENTREPRENEUR)
      return [
        state.agentRoles[agentRoles.ADVISOR_LEVEL1],
        state.agentRoles[agentRoles.ADVISOR_LEVEL2],
        state.agentRoles[agentRoles.SUPERVISOR],
        state.agentRoles[agentRoles.ENTREPRENEUR],
      ];

    let roles = Object.values(state.agentRoles);
    return roles;
  },
  getAgentRolesToArray(state) {
    let roles = Object.values(state.agentRoles);

    if (!state.agent.system_agent) roles = roles.filter((r) => r.id !== state.agentRoles.entrepreneur.id);

    return roles;
  },
  getAgentSelected(state) {
    return state.agentSelected;
  },
  getAgentId(state) {
    return state.agentId;
  },
  showAgentDetailDrawer(state) {
    return state.showAgentDetailDrawer;
  },
  getAgentIntegrations(state) {
    return state.agentIntegrations;
  },
  getMenuOptions(state) {
    return state.menu;
  },
};
